import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { addDocumentDownloadRequest } from '../../../../../../store/modules/articles/actions';
import { DocumentRef } from '../../../../../../types/items';
import { Action } from '../../../../../../components/index';
import { DownloadIcon } from '../../../../../../components/icon/solid';
import { MediaStyles } from '../styles';

type Props = {
  document: DocumentRef | null;
};

const DownloadDocumentAction = ({ document }: Props) => {
  const classes = MediaStyles();
  const dispatch = useDispatch();

  const clickHandler = useCallback(() => {
    if (document !== null) {
      dispatch(addDocumentDownloadRequest({
        documentId: document.id,
        mimeType: document.mime_type_id,
        title: document.ref.filename_base,
      }));
    }
  }, [dispatch, document]);

  return (
    <Action
      icon={<DownloadIcon className={classes.actionIcon} />}
      title="Download"
      onClick={clickHandler}
    />
  );
};

export default DownloadDocumentAction;
